/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Openquestionskindother3Inputs */

const en_openquestionskindother3 = /** @type {(inputs: Openquestionskindother3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Question`)
};

const pt_openquestionskindother3 = /** @type {(inputs: Openquestionskindother3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questão`)
};

/**
* | output |
* | --- |
* | "Question" |
*
* @param {Openquestionskindother3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const openquestionskindother3 = /** @type {((inputs?: Openquestionskindother3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Openquestionskindother3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_openquestionskindother3(inputs)
	return pt_openquestionskindother3(inputs)
});
export { openquestionskindother3 as "openQuestionsKindOther" }